import React from "react";

const faq7 = () =>{
  return(
    <>
      <p>
        Täckningsbidraget (TB) är det firman lever 
        på och en viktig mätare på lönsamhet. 
        Kalkyleras som  
      </p>
      <p className="ms-4">
        <i>Intäkt – rörlig kostnad = TB</i>
      </p>
      <p>
        TB är alltså det som finns kvar när 
        kostnader för att
        <ul className="mb-0">
          <li>Skapa</li>
          <li>Producera</li>
          <li>Marknadsföra och sälja</li>
          <li>Leverera </li>
        </ul>
        har dragits från erbjudandets intäkt.
      </p>
      <p>
        Ju större avstånd mellan intäktström och 
        kostnadsmassa ju bättre potentiellt TB.
      </p>
      <p>
        Används bl a för att bedöma och jämföra 
        olika erbjudandens förmåga att bidra till 
        firmans kostnader.
      </p>
      <p>
        Se Flik: <u>Fält & Rubriker t o m. Täckningsbidrag</u>
      </p>
    
    </>
  );
}
export default faq7;